import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { Bundle, ScheduleGroup } from '@paragon/contract-library';

interface ScheduleGroupsState {
  [scheduleGroupGuid: string]: ScheduleGroup;
}

const initialState: ScheduleGroupsState = {};

const scheduleGroupsSlice = createSlice({
  name: 'scheduleGroups',
  initialState,
  reducers: {
    scheduleGroupsLoaded: (state, action: PayloadAction<readonly ScheduleGroup[]>) => {
      for (const scheduleGroup of action.payload) {
        state[scheduleGroup.guid] = castDraft(scheduleGroup);
      }
    },
    scheduleGroupCreated: (state, action: PayloadAction<ScheduleGroup>) => {
      state[action.payload.guid] = action.payload;
    },
    scheduleGroupDeleted: (
      state,
      action: PayloadAction<{ scheduleGroupGuid: string; updatedBundles: readonly Bundle[] }>,
    ) => {
      delete state[action.payload.scheduleGroupGuid];
    },
  },
});

export const { scheduleGroupsLoaded, scheduleGroupCreated, scheduleGroupDeleted } = scheduleGroupsSlice.actions;
export const scheduleGroups = scheduleGroupsSlice.reducer;
